import React from 'react';
import styles from './PaymentsComparisonDisclaimer.module.scss';

import type { FlatEntry } from 'services/cms/flattenContentful';
import type { Subject } from 'api/contentful/contentTypes.cloverdotcom';
import { componentKeyV2 } from 'utils/ComponentKeyV2';
import { TextV2 } from 'components/TextV2/TextV2';

interface IPaymentsComparisonDisclaimerProps {
  disclaimerItems: FlatEntry<Subject>[];
}

export const PaymentsComparisonDisclaimer: React.FC<IPaymentsComparisonDisclaimerProps> = ({
  disclaimerItems,
}) => {
  if (!disclaimerItems?.length) return null;

  return (
    <>
      {disclaimerItems.map((item, index) => {
        return (
          <div key={componentKeyV2(item, index)}>
            <TextV2
              isMarkdown
              id={item?.blurb}
              value={item?.blurb}
              variant="body-small"
              tagName="div"
              className={styles.footerTextItem}
            />
          </div>
        );
      })}
    </>
  );
};
